import { render } from "./TermineView.vue?vue&type=template&id=986c6e96"
import script from "./TermineView.vue?vue&type=script&lang=js"
export * from "./TermineView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__